import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';

const DNBMDOrderProvider = (props) => {
  const api = new API();
  const [DNBMDOrderCatList, setDNBMDOrderCatList] = useState([]);
  const [DNBMDOrderSubCatList, setDNBMDOrderSubCatList] = useState([]);
  const [DNBMDOrderCatListLoader, setDNBMDOrderCatListLoader] = useState(false);
  const [DNBMDOrderSubCatListLoader, setOrderSubCatListLoader] = useState(false);
  const [DNBMDOrderTableFilter, setDNBMDOrderTableFilter] = useState({
    page: 1,
    limit: 100,
  })
  const [DNBMDOrderList, setDNBMDOrderList] = useState([]);
  const [subCatOrderId, setSubCatOrderId] = useState("");
  const [DNBMDOrderListLoader, setDNBMDOrderListLoader] = useState(false);
  const fetchDNBMDOrderCatList = async () => {
    setDNBMDOrderCatListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("dnbmdorder/categorylist", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setDNBMDOrderCatList(res?.data?.data);
        } else {
          setDNBMDOrderCatList([]);
        }
        setDNBMDOrderCatListLoader(false);
      }));
  }
  const fetchDNBMDOrderSubCatList = async (cid) => {
    setOrderSubCatListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("dnbmdorder/subcategorylist", {
        category_id: cid
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setDNBMDOrderSubCatList(res?.data?.data);
        } else {
          setDNBMDOrderSubCatList([]);
        }
        setOrderSubCatListLoader(false);
      }));
  }
  const fetchDNBMDOrderList = async (data) => {
    setDNBMDOrderListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setSubCatOrderId(data?.subcategory_id);
    (await api.getAll("dnbmdorder/examtablelist_v3", {
        category_id: data?.category_id,
        subcategory_id: data?.subcategory_id,
        ...DNBMDOrderTableFilter
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setDNBMDOrderList(res?.data?.data);
        } else {
          Widget.showMessage('error',err?.response?.data?.message);
          setDNBMDOrderList([]);
        }
        setDNBMDOrderListLoader(false);
      }));
  }

  const fetOrderDNBMDSub = async (data) => {
    return await api.create("pearlsorder/suborder_v2", {
      ids: data,
      subcategory_id: subCatOrderId,
      type: "dnbmd",
      level: "subject"
    }, (err, res) => {
      if(err){
        Widget.showMessage('error',err?.response?.data?.message);
      }
    });
  }
  const fetOrderDNBMDTopic = async (data, level = "topic") => {
    return await api.create("pearlsorder/suborder_v2", {
      ids: data,
      subcategory_id: subCatOrderId,
      type: "dnbmd",
      level: level
    }, (err, res) => {
      if(err){
        Widget.showMessage('error',err?.response?.data?.message);
      }
    });
  }

   return (
    <Context.Provider value={{
      ...props,
      DNBMDOrderCatList, setDNBMDOrderCatList,
      DNBMDOrderSubCatList, setDNBMDOrderSubCatList,
      DNBMDOrderCatListLoader, setDNBMDOrderCatListLoader,
      DNBMDOrderSubCatListLoader, setOrderSubCatListLoader,
      DNBMDOrderTableFilter, setDNBMDOrderTableFilter,
      DNBMDOrderList, setDNBMDOrderList,
      DNBMDOrderListLoader, setDNBMDOrderListLoader,
      fetchDNBMDOrderCatList,
      fetchDNBMDOrderSubCatList,
      fetchDNBMDOrderList,
      fetOrderDNBMDSub,
      fetOrderDNBMDTopic,
      subCatOrderId, setSubCatOrderId
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default DNBMDOrderProvider;

